import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'viewHour'
})
export class viewHourPipe implements PipeTransform {

    transform(value:string,splitBy:string =':') {
        try{
            let [hour,minute] = value.split(splitBy);
            let returnString = value;
            if(hour && minute){
                returnString = '';
                if(+hour > 0){
                    returnString = +hour + (+hour >= 2 ? ' Hours ' : ' Hour ');
                }
                if(+minute > 0){
                    returnString += +minute + (+minute >= 2 ? ' Minutes' : ' Minute');
                }
            }
            return returnString;
        }   
        catch(err){
            console.log(err);
        }
    }
}